<template>
    <input
        class="
            w-full
            text-xs text-secondary
            font-medium
            rounded
            border-0
            px-5
            py-3
            focus:outline-none focus:ring-0
        "
        :value="modelValue"
        :placeholder="placeholder"
        @input="$emit('update:modelValue', $event.target.value)"
        ref="input"
    />
</template>

<script>
export default {
    props: ["modelValue", "placeholder"],

    emits: ["update:modelValue"],

    methods: {
        focus() {
            this.$refs.input.focus();
        },
    },
};
</script>
